import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  DataTable,
  Field,
  DateTimeField,
  ContractEONType,
  ContractTypeBadgeField,
  CurrencyField,
  BooleanField,
  ResponsibleField,
} from '../../../commons/DataTable';
import ContractCheckbox from './ContractCheckbox';
import ActionsField from '../Royalties/ActionsField';
import TotalTr from './TotalTr';
import AdminStateEnergyField from '../../../commons/DataTable/AdminStateEnergyField';
import CurrencyFieldCentMc from '../../../commons/DataTable/CurrencyFieldCentMc';
import CurrencyFieldInitialFixedValue from '../../../commons/DataTable/CurrencyFieldInitialFixedValue';
import ManageDocument from './ManageDocument';
import CurrentAdminField from '../../../commons/DataTable/CurrentAdminField';
import { ENERGY_USERS_ADMIN } from '../../../App';

function ContractsTableEnergyTab({
  data,
  total,
  offset,
  limit,
  onFilter,
  selectedContracts,
  onSelectChange,
  onSelectAll,
  selectedAll,
  setModalState,
  profileType,
  profile,
  handleFileListView,
}) {
  const [t] = useTranslation('IAF_INVOICES');

  const onRowClick = (row) => {
    const { _id } = row;
    if (!row.pinvInvoice?.length > 0) {
      onSelectChange(row);
    }
  };

  const formattedData = data?.map((elem) => {
    return {
      ...elem,
      customerType:
        elem.customerType === 'condos'
          ? 'CONDOMINIO'
          : !elem.customerType
          ? 'CONDOMINIO'
          : elem.customerType === 'utilizers'
          ? 'UTILIZZATORE'
          : 'CLIENTE',
    };
  });

  const getTotals = (data) => {
    const extraShareTotals = data.reduce(
      (prev, cur) => prev + cur.extraShare,
      0
    );
    const adminShareTotals = data.reduce(
      (prev, cur) => prev + cur.adminShare,
      0
    );
    const contractValueTotals = data.reduce(
      (prev, cur) => prev + cur.contract_value,
      0
    );

    return {
      extraShareTotals,
      adminShareTotals,
      contractValueTotals,
    };
  };

  return (
    <DataTable
      data={formattedData}
      total={total}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
      emptyText={t('COMMON:NO_DATA')}
      bottomRow={
        <TotalTr
          profileType={profileType}
          totals={getTotals(data)}
          profile={profile}
        />
      }
    >
      <ContractCheckbox
        selected={selectedContracts}
        onSelectChange={onRowClick}
        onClick={(e) => e.stopPropagation()}
        title={
          <input
            type="checkbox"
            checked={selectedAll}
            onChange={({ target: { checked } }) => onSelectAll(checked)}
          />
        }
      />
      <Field title="POD/PDR" source="pod_pdr" />
      <ContractTypeBadgeField title="Voce" source="partnerEonType" />
      <Field title="Nome cliente" source="condo_name" className="text-left" />
      <Field title="Tipologia Cliente" source="customerType" />
      <Field title="Partita iva detentore" source="currentAdminInfo.taxCode" />
      <Field title="Partita IVA cliente" source="condo_vat_cf" />
      <DateTimeField
        title="Data creazione"
        source="contract_signing_date"
        format="DD/MM/YYYY"
      />
      <DateTimeField
        title="Data attivazione"
        source="activation_start_date"
        format="DD/MM/YYYY"
      />
      <Field
        title="Consumo da contratto iniziale"
        source="initial_contractual_consumption"
        hideForStorno
      />
      <Field
        title="Consumo da contratto"
        source="contractual_consumption"
        hideForStorno
      />
      <Field
        title="Consumo attuale"
        source="actual_consumption"
        hideForStorno
      />
      <ContractEONType
        title="Nome prodotto"
        source="product_name"
        hideForStorno
      />
      <CurrentAdminField title="Detentore" source="currentAdminInfo.name" />
      <ResponsibleField title="Intestatario" source="admin.name" />
      <AdminStateEnergyField title="Stato Gestione" hideForStorno />
      <DateTimeField
        title="Data Scadenza"
        source="contract_end_date"
        format="DD/MM/YYYY"
        hideForStorno
      />
      <BooleanField
        title="Abilitazione fattura"
        source="iafPolis"
        visible={profile.polis === true}
      />
      <DateTimeField
        title="Data abilitazione fattura"
        source="iaf_polis_date"
        format="DD/MM/YYYY"
        visible={profile.polis === true}
      />
      <CurrencyFieldInitialFixedValue
        title="Compenso fisso iniziale"
        source="energy_contract.initial_fixed_value"
        hideForStorno
      />
      <CurrencyFieldCentMc title="Fee iniziale a mc" hideForStorno />
      <CurrencyField title="Imponibile" source="contract_value" />
      <CurrencyField title="Profitto Extra" source="extraShare" />
      <CurrencyField title="Profitto Intestatario" source="adminShare" />
      <ManageDocument
        title="Gestisci documento"
        handleFileListView={handleFileListView}
        visible={
          profile.polis === true || ENERGY_USERS_ADMIN.includes(profileType)
        }
        hideForStorno
      />
      <ManageDocument
        title="Gestisci Report"
        handleFileListView={handleFileListView}
        visible={
          profile.polis === true || ENERGY_USERS_ADMIN.includes(profileType)
        }
        isReport={true}
        hideForStorno
      />
      <ActionsField
        title="Fattura Extra"
        onViewInvoice={(extraInvoiceId) =>
          setModalState({ isOpen: true, selectedId: extraInvoiceId })
        }
      ></ActionsField>
    </DataTable>
  );
}

export default ContractsTableEnergyTab;
